//TODO: Make it dynamic based on Data OR API
export const createEntityPIDHeaders = [
  { title: 'Entity ID' },
  { title: 'Business Name' },
  {
    title: 'Type',
  },
  { title: 'Level' },
  { title: 'Status' },
  {
    title: 'Action',
  },
]

export const createEntityMASMIDHeaders = [
  {
    title: 'Business Name',
  },
  {
    title: 'Type',
  },
  {
    title: 'MAS MID',
  },
  {
    title: 'Status',
  },
]
export const createEntityPIDData = [
  {
    businessName: 'RPSL POS',
    type: 'Entity',
    level: 'L2',
    masMid: 'NA',
    status: 'Active',
    viewDetails: 'View Details',
  },
]

export const createEntityMIDMASMapper: any = {
  0: 1,
  1: 1,
  2: 1,
  3: 1,
}

export const createEntityflexMapper: any = {
  0: 1,
  1: 1,
  2: 1,
  3: 1,
  4: 1,
  5: 1,
}

export const getKeyExtractor = (itemData: any, index: number): string => {
  return `${itemData?.fileName}_${index}`
}
